// extracted by mini-css-extract-plugin
module.exports = {"MoreInfo":"MoreInfo_MoreInfo__ZNa__"};